// 物件 ES6 封裝
// ES6 必需 EXPORT 出物件才能被 import 使用
import { oltConsole } from '@/lib/oltModule/oltConsole';
import axios from 'axios';


export class oltRestApi{

  constructor () {
    this.params = {} ;
    this.restApiUrl = '';
    this.authHeader = {} ;
    if(oltConsole.oltExpire === true){
      oltConsole.sysExpireAlert();
    }
  }

  // conditon method start 
  conditionParam(param){
    //oltConsole.log('conditionParam : ', param);

    if(param.data){
      this.params = param.data;
    }
    if(param.url){
      this.restApiUrl = param.url; 
    }
    if(param.authorizationType && param.authorizationCredentials){
      if(param.authorizationType == 'Basic'){
        this.authHeader = {
          'Authorization': 'Basic '+param.authorizationCredentials,
        };
      }
      else if(param.authorizationType == 'Bearer'){
        this.authHeader = {
          'Authorization': 'Bearer '+param.authorizationCredentials,
        };
      }
    }
    if(param.apiDebug){
      oltConsole.setDebugMode(param.apiDebug);
    }
  }

  conditionDebug(param,message,debug){

    if(param){
      oltConsole.setDebugMode(param.apiDebug);
      oltConsole.setDebugMode(debug);
      oltConsole.log(message);
      oltConsole.log('./-> function->params : ');
      oltConsole.log(param);
      oltConsole.log('./-> this.params : ');
      oltConsole.log(this.params);
      oltConsole.log('./../-> restApiUrl : ' + this.restApiUrl );
      oltConsole.log('./../-> authHeader : ' + this.authHeader );
    }
  }


  // conditon method end 


  getAll(param){
    //console.log('send : ', param);
    this.conditionParam(param); // init this.params
    this.conditionDebug(param, '[API]oltRestApi send() : ', false);
    
    // Promise 進行異步 IO 封裝並且回傳。
    return new Promise((resolve, reject) =>{
      axios(
        {
          method:'get' ,
          url: this.restApiUrl,
          params: this.params, 
          headers: this.authHeader,
        })
        .then(res => {
          oltConsole.log('./-> res : ') ;
          oltConsole.log(res);
          resolve(res.data);
        })
        .catch(err =>{
          oltConsole.log('./-> err : ') ;
          oltConsole.log(err);
          oltConsole.log(err.response) ;
          reject(err);
        });
    }) ;    
  }



}
oltConsole.sysExpireTime();
